/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import ImageComponent from "./image";

function Image({ src, alt, placeholder, className }) {
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {}, [isLoaded]);

  const handleImageLoaded = () => {
    setLoaded(true);
  };

  return (
    <ImageComponent
      src={src}
      alt={alt}
      isLoaded={isLoaded}
      placeholder={placeholder}
      onLoad={handleImageLoaded}
      className={className}
    />
  );
}

export default Image;
